import { P2Span } from "@constellation-academy/epic-ui";
import React from "react";
import { clozeTextLearnElementWrapper } from "@components/cloze-text-learn-element/cloze-text-learn-element.styles";
import { matrixElementListItem } from "@components/matrix-learn-element/matrix-learn-element.styles";
import { MatrixLearnElementProps } from "@components/matrix-learn-element/matrix-learn-element.types";
import {
	answerTextCorrect,
	answerTextWrong,
} from "@components/multiple-choice-gap-text/multiple-choice-gap-text.styles";
import {
	correctAnswerTitle,
	wrongAnswerTitleClass,
} from "@screens/elearning-content-submission/parts/lesson-insights/lesson-insights.styles";

export const MatrixLearnElementComponent = ({ isResultWrong }: MatrixLearnElementProps) => {
	return (
		<div className={clozeTextLearnElementWrapper}>
			<h6 className={isResultWrong ? wrongAnswerTitleClass : correctAnswerTitle}>
				Deine Antwort
			</h6>
			<div className={matrixElementListItem}>
				<P2Span className={isResultWrong ? answerTextWrong : answerTextCorrect}>
					{isResultWrong ? "Falsch ausgefüllt" : "Richtig ausgefüllt"}
				</P2Span>
			</div>
		</div>
	);
};
